import { render, staticRenderFns } from "./TelegramSetting.vue?vue&type=template&id=79d36608&"
import script from "./TelegramSetting.vue?vue&type=script&lang=ts&"
export * from "./TelegramSetting.vue?vue&type=script&lang=ts&"
import style0 from "./TelegramSetting.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TelegramSetting.vue"
export default component.exports